'use strict';

var $ = require('jquery');

function init() {
	var $gallery = $('.gallery');
	if ($gallery.length === 0) {
		return;
	}

	$gallery.each(function() {
		var $elem = $(this);

		var $galleryView 	= $elem.find('.gallery__view');
		var $galleryThumb 	= $elem.find('.gallery__thumb');
		var hasControls 	= $elem.hasClass('gallery--hasControls');
		var removeOldMediaTimeoutID = undefined;

		var galleryControls = {
			currIndex: 0,
			maxIndex: $galleryThumb.length - 1,
			controlsCreated: false,
			createControls: function(){
				this.next = $('<button class="nextControl btn" title="Next"><span>Next</span></button>').appendTo($galleryView);
				this.prev = $('<button class="prevControl btn" title="Previous"><span>Prev</span></button>').appendTo($galleryView);
				this.next.on('click', function (){
					if ( $(this).hasClass('disabled') ){
						return;
					}
					galleryControls.update(1);
				});
				this.prev.on('click', function (){
					if ( $(this).hasClass('disabled') ){
						return;
					}
					galleryControls.update(-1);
				});
				this.controlsCreated = true;
				this.toggleControls();
			},
			update: function(num){
				num = num || 0;
				var newIndex = this.currIndex + num;
				if (newIndex <= this.maxIndex && newIndex >= 0){
					$galleryThumb.eq(newIndex).find('.image').trigger('click');
					this.currIndex = newIndex;
				}
				this.toggleControls();
			}, notifyOfChange: function(newIndex) {
				this.currIndex = newIndex || 0;
				this.toggleControls();
			}, toggleControls: function(){
				if (this.controlsCreated){
					this.prev.toggleClass('disabled', (this.currIndex == 0));
					this.next.toggleClass('disabled', (this.currIndex == this.maxIndex));
				}
			}, init: function(){
				this.currIndex = $galleryThumb.filter('.active').index();
				this.createControls();
			}
		};
		if (hasControls){
			galleryControls.init();
		}


		function removeOldMedia() {
			// Remove all but first one
			var $mediaElements = $galleryView.find('.gallery__media');
			for (var i = 1; i < $mediaElements.length; i++) {
				var $media = $($mediaElements[i]);
				$media.remove();
			}

			$galleryView.removeClass('loading');

			removeOldMediaTimeoutID = undefined;
		}
		function clickHandler(event) {
			event.preventDefault();

			var $this = $(this);
			var href = $this.attr('href');
			var alt = $this.find('img.rigid').attr('alt');
			alt = typeof alt === 'undefined' ? ' ' : alt;
			var $galleryMedia = $galleryView.find('.gallery__media');

			if ($galleryMedia.attr('src') !== href) {
				var idx = $galleryThumb.index($(event.target).closest('a').parent());
				if (removeOldMediaTimeoutID !== undefined) {
					clearTimeout(removeOldMediaTimeoutID);
				}
				removeOldMedia();

				// Remove 'active' class from all thumbnails and then add to
				// current
				$galleryThumb.removeClass('active');
				$this.parent().addClass('active');
				$this.parent().trigger('analyticsEvent');

				// Load the new media
				$galleryView.addClass('loading');
				var strImage = '<div class="gallery__media"><img src="' + href + '" alt="' + alt + '" /></div>';
				$galleryView.prepend($(strImage));
				galleryControls.notifyOfChange(idx);//.update(idx);

				// Have media removing removed once done
				removeOldMediaTimeoutID = window.setTimeout(removeOldMedia,
						1000);
			}
		}

		$galleryThumb.on('click', 'a', clickHandler);
	});
}
module.exports = {
	init : init
};
